<template>
  <div class="wrap">
    <div class="chapter_box" v-if="!empty">
      <el-tree
        :data="list"
        node-key="chapterId"
        :props="{
          children: 'children',
          label: 'title',
        }"
        :default-expand-all="true"
      >
        <span
          class="custom-tree-node"
          :class="{ catalog: !data.parentId }"
          slot-scope="{ node, data }"
        >
          <span>
            <span class="left-icon" v-if="data.children">
              <img
                :src="
                  node.expanded
                    ? require('@/assets/images/icons/close.png')
                    : require('@/assets/images/icons/open.png')
                "
                alt=""
              />
            </span>
            <span class="left-dot" v-else> </span>
            <span>{{ data.title }}</span>
            <el-tag
              v-if="data.sz"
              style="margin-left: 10px"
              effect="dark"
              size="mini"
              >实训</el-tag
            >
            <el-tag
              v-if="data.mock"
              style="margin-left: 10px"
              effect="dark"
              type="warning"
              size="mini"
              >仿真实训</el-tag
            >
            <el-tag
              v-if="data.teamGrade"
              style="margin-left: 10px"
              effect="dark"
              type="success"
              size="mini"
              >评价</el-tag
            >
          </span>
          <span v-if="data.type == 'CHAPTER'">
            <uploadFile
              v-show="showUpData"
              style="display: inline-block"
              :fileType="[]"
              @success="uploadSuccess"
              @click.native.stop="params.classChapterId = data.classChapterId"
            >
              <el-button class="btn" size="mini" type="info" plain
                >资源补充</el-button
              >
            </uploadFile>

            <el-button
              v-show="showEnter"
              class="btn"
              size="mini"
              type="primary"
              plain
              @click="goDetail(data.classChapterId, data.chapterId, data.title)"
              >进入章节</el-button
            >
          </span>
        </span>
      </el-tree>
      <!-- <div class="catalog_row" v-for="item in list" :key="item.chapterId">
        <p class="catalog_title">{{ item.title }}</p>
        <div
          class="row"
          v-for="chapter in item.children"
          :key="chapter.chapterId"
        >
          <div style="display: inline-block">
            <p class="title">
              {{ chapter.title }}
            </p>
            <el-tag
              v-show="chapter.sz"
              style="margin-left: 10px"
              effect="dark"
              size="mini"
              >实训</el-tag
            >
          </div>

          <div class="btns">
            <uploadFile
              v-show="showUpData"
              style="display: inline-block"
              :fileType="[]"
              @success="uploadSuccess"
              @click.native.stop="
                params.classChapterId = chapter.classChapterId
              "
            >
              <el-button class="btn" size="mini" type="info" plain
                >资源补充</el-button
              >
            </uploadFile>

            <el-button
              v-show="showEnter"
              class="btn"
              size="mini"
              type="primary"
              plain
              @click="goDetail(chapter.classChapterId, chapter.title)"
              >进入章节</el-button
            >
          </div>
        </div>
      </div> -->
    </div>
    <el-empty description="暂无章节~" :image-size="200" v-else></el-empty>
  </div>
</template>

<script>
import { handleTree } from "@/utils";
import uploadFile from "@/components/uploadFile";
import { addAnnex } from "@/api/assistantMode/annex";
import { chapterList } from "@/api/assistantMode/chapter";
const PERMISSIONS = [
  { path: "/assistantMode/courseDetail/data", label: "ANNEX" },
  { path: "/assistantMode/courseDetail/practice", label: "TASK" },
  { path: "/assistantMode/courseDetail/works", label: "WORKS" },
  { path: "/assistantMode/courseDetail/activity", label: "ACTIVITY" },
  { path: "/assistantMode/courseDetail/appraise", label: "QUALITY" },
];
export default {
  name: "chapters",
  components: {
    uploadFile,
  },
  props: {
    permissions: Array,
    showUpData: Boolean,
    showEnter: Boolean,
  },
  data() {
    return {
      sections: [],
      list: [],
      empty: false,
      params: {
        classChapterId: "",
        fileId: "",
      },
      currentChapter: {},
      notTitles: [],
      currentChapterId: null,
      currentChapterTitle: "",
    };
  },
  created() {
    this.getChapterList();
  },
  methods: {
    // 章节列表
    getChapterList() {
      this.$loading.show();
      chapterList({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = handleTree(res.data, "chapterId");
          this.empty = this.list && this.list.length > 0 ? false : true;
          this.sections = res.data.filter((item) => {
            return item.type == "CHAPTER";
          });
        } else {
          console.log(res.msg);
        }
      });
    },
    goDetail(classChapterId, chapterId, chapterTitle) {
      let next = PERMISSIONS.find((p) => {
        return this.permissions.find((item) => {
          return p.label == item;
        });
      });
      this.$router.push({
        path: next.path,
        query: {
          ...this.$route.query,
          classChapterId,
          chapterId,
          chapterTitle,
        },
      });
    },
    // 上传成功
    uploadSuccess(file) {
      this.params.fileId = file.fileId;
      addAnnex(this.params).then((res) => {
        if (res.code == 0) {
          this.$message.success("上传成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  margin-bottom: 30px;

  .chapter_box {
    background-color: #fff;
    ::v-deep .el-tree {
      .el-tree-node {
        .el-tree-node__content {
          height: 40px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          .el-tree-node__expand-icon {
            display: none;
          }
        }
      }
    }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      padding: 0 16px;
      height: 40px;
      &.catalog {
        font-size: 17px;
        color: #303133;
        font-weight: bold;
        background-color: #f0f7ff;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      }
      .left-icon {
        margin-right: 16px;
        img {
          width: 18px;
          height: 18px;
        }
      }
      .left-dot {
        display: inline-block;
        margin: 0 16px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #1890ff;
      }
      .btn {
        margin-left: 10px;
      }
    }
  }

  .catalog_row,
  .row {
    line-height: 40px;
    text-align: left;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    &.catalog_row {
      border-bottom: none;
    }
    &.row {
      padding: 0 15px;
      transition: all 0.3s ease;

      &:hover {
        background-color: rgb(245, 245, 245);
      }
    }

    .catalog_title,
    .title {
      display: inline-block;
      margin-left: 16px;
      max-width: 715px;
      height: 40px;
      font-size: 16px;
      // font-weight: bold;
      color: #606266;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      vertical-align: middle;
      &.catalog_title {
        max-width: 100%;
        font-size: 17px;
        color: #303133;
        font-weight: bold;
      }
    }

    .btns {
      float: right;

      .btn {
        margin-left: 10px;
        font-size: 14px;
      }
    }
  }
}
</style>